export default {
  path: '/expert',
  name: 'Expert',
  redirect: '/expert/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list', 
      component: () => import('@/views/export/performance/PerformancePhaseList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'unAuditYouthList',
      component: () => import('@/views/export/performance/UnAuditYouthList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'unAuditTargetList',  
      component: () => import('@/views/export/performance/UnAuditTargetList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'expertList', 
      component: () => import('@/views/export/expertManagement/List'),
      meta: { requiresAuth: true }
    }
  ]
}
